import { SvgIcon, SvgIconProps } from '@mui/material';
import React, { ReactElement } from 'react';

export interface MoreSharingIconProps extends SvgIconProps {}

export const MoreSharingIcon = (props: MoreSharingIconProps): ReactElement => {
  return (
    <SvgIcon style={{ fontSize: '1em' }} {...props} viewBox="0 0 25 25">
      <path
        d="M19.7917 25.0007H2.08333C0.934896 25.0007 0 24.0658 0 22.9173V4.16732C0 3.01888 0.934896 2.08398 2.08333 2.08398H14.0625C14.3503 2.08398 14.5833 2.31706 14.5833 2.60482C14.5833 2.89258 14.3503 3.12565 14.0625 3.12565H2.08333C1.50911 3.12565 1.04167 3.5931 1.04167 4.16732V22.9173C1.04167 23.4915 1.50911 23.959 2.08333 23.959H19.7917C20.9401 23.959 21.875 23.0241 21.875 21.8757V10.9382C21.875 10.6504 22.1081 10.4173 22.3958 10.4173C22.6836 10.4173 22.9167 10.6504 22.9167 10.9382V21.8757C22.9167 23.5983 21.5143 25.0007 19.7917 25.0007Z"
        fill="#23305F"
        stroke="#23305F"
        strokeWidth="0.75"
        strokeLinejoin="round"
      />
      <path
        d="M24.4792 8.33407C24.1915 8.33407 23.9584 8.10099 23.9584 7.81323V1.0424H17.1876C16.8998 1.0424 16.6667 0.809326 16.6667 0.521566C16.6667 0.233805 16.8998 0.000732422 17.1876 0.000732422H24.4792C24.767 0.000732422 25.0001 0.233805 25.0001 0.521566V7.81323C25.0001 8.10099 24.767 8.33407 24.4792 8.33407Z"
        fill="#23305F"
        stroke="#23305F"
        strokeWidth="0.5"
      />
      <path
        d="M12.5001 13.0216C12.3673 13.0216 12.2332 12.9708 12.1316 12.8692C11.9285 12.6661 11.9285 12.3367 12.1316 12.1322L24.1108 0.153076C24.3139 -0.0500488 24.6446 -0.0500488 24.8477 0.153076C25.0509 0.356201 25.0509 0.685628 24.8477 0.890055L12.8686 12.8692C12.767 12.9708 12.6342 13.0216 12.5001 13.0216Z"
        fill="#23305F"
        stroke="#23305F"
        strokeWidth="0.75"
      />
    </SvgIcon>
  );
};
